import { Grid } from "@material-ui/core";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import { LOCKED_STATUS } from "app/common/LocalConst";
import { transformDate } from "app/common/LocalFunction";
import PaymentVoucherPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/FeeTab/Popup/PaymentVoucherPopup";
import ProductHistoryPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/RegisterProductTab/Popup/ProductHistoryPopup";
import RequestStoreExportProductsPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/RegisterProductTab/Popup/RequestStoreExportProductsPopup";
import { lockProduct } from "app/services/EncounterService";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect } from "react";
import * as Yup from "yup";
import LockRetainedPopup from "../../FeeTab/Popup/LockRetainedPopup";
import ChangeProductToClientCardPopup from "../Popup/ChangeProductToClientCardPopup";
import HistoryProductPopup from "../Popup/HistoryProductPopup";
import ListStoreRequestItemPopup from "../Popup/ListStoreRequestItemPopup";
import RequestStoreReturnProductsPopup from "../Popup/RequestStoreReturnProductsPopup";
import RegisterProductPopup from "../Popup/RegisterProductPopup";
import RegisterProductPreviewPrintPopup from "../Popup/RegisterProductPreviewPrintPopup";
import ListRegisterProduct from "./ListRegisterProduct";
import SearchRegisterProduct from "./SearchRegisterProduct";

const RegisterProductIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchProduct({
        ...searchRegisterProduct,
        patientId,
        fromDate: null,
        toDate: null,
      });
      getListPaymentMethod();
      getTreatmentFree();
    }
  }, [patientId]);
  const {
    openConfirmDelete,
    handleOpenConfirmDelete,
    handleDeleteProduct,
    handleCloseConfirmMessage,
    searchRegisterProduct,
    handleChangeFormSearchProduct,
    openCreateOrEditProductPopup,
    handleCloseCreateOrEditProductPopup,
    saveOrUpdateRegisterProduct,
    initRegisterProduct,
    resetPopupStore,
    printContent,
    handleSetPrintContent,
    openRequestStoreExportProductsPopup,
    selectedProductOrders,
    setSelectedProductOrders,
    initListStoreRequestItem,
    openListStoreRequestItemPopup,
    handleCloseListStoreRequestItemPopup,
    openConfirmDeleteMessage,
    handleCloseDeleteConfirmMessage,
    openProductHistoryPopup,
    handleCloseProductHistoryPopup,
    openChangeProductPopup,
    initChangeProduct,
    handleCloseChangeeProductPopup,
    handleSubmitChangeProduct,
    openConfirmUnlock,
    handleCloseConfirmUnlock,
    handleConfirmUnlock,
    openConfirmError,
    handleOpenConfirmError,
    openConfirmLock,
    handleCloseConfirmLock,
    handleConfirmLock,
    treatmentFree,
    getTreatmentFree,
    openHistoryProductPopup,
    handleCloseHistoryProductPopup,
    handleChangeFormSearchHistory,
    searchDataHistory,
    pageDataHistory,
    pagingRegisterProduct,
    pageRegisterProduct,
  } = useStore().patientManagementStore.registerProductStore;

  const {
    listStk,
    listPos,
    listHomecredit,
    listPos_tragop,
    openPaymentVoucherPopup,
    initialPaymentVoucher,
    createPaymentVoucherWithListMethod,
    listPaymentMethod,
    getListPaymentMethod,
    handleClosePaymentVoucherPopup,
    openTotalBillStatusInvoiceItemConfirm,
    handleCloseTotalBillStatusInvoiceItemConfirm,
    updateTotalBillStatusInvoiceItem,
    openFormLockRetained,
    handleCloseFormLockRetaind,
    initialLockRetained,
    handleLockRetaind,
    defaultFreePromotion,
  } = useStore().feeStore.serviceFeeTabStore;

  const {
    listVatPercent,
    initialPatient,
    customerSourceWalkIn,
    handleGetPatientOverviewByIdNotLoading,
  } = useStore().patientManagementStore.patientGeneralStore;

  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });

  return (
    <Grid xs={12} sm={12}>
      <Formik
        initialValues={searchRegisterProduct}
        validationSchema={searchPatientValidationSchema}
        onSubmit={(values) => {
          handleChangeFormSearchProduct(values);
        }}
        enableReinitialize
      >
        <Form autoComplete="off">
          <SearchRegisterProduct
            selectedProductOrders={selectedProductOrders}
          />

          <ListRegisterProduct
            selectedProductOrders={selectedProductOrders}
            setSelectedProductOrders={setSelectedProductOrders}
          />

          {!!openCreateOrEditProductPopup && (
            <RegisterProductPopup
              open={!!openCreateOrEditProductPopup}
              handleClose={handleCloseCreateOrEditProductPopup}
              onSubmit={saveOrUpdateRegisterProduct}
              initRegisterProduct={{ ...initRegisterProduct, patientId }}
              listVatPercent={listVatPercent}
              handleAfterSubmit={() =>
                handleGetPatientOverviewByIdNotLoading(patientId)
              }
              resetPopupStore={resetPopupStore}
              customerSourceWalkIn={customerSourceWalkIn}
              defaultFreePromotion={defaultFreePromotion}
            />
          )}

          {!!openRequestStoreExportProductsPopup && (
            <RequestStoreExportProductsPopup
              patient={initialPatient?.patientInfo}
            />
          )}

          {openConfirmDelete && (
            <ConfirmPopup
              open={openConfirmDelete}
              onClose={() => handleOpenConfirmDelete(null)}
              text="Bạn có chắc chắn muốn hủy sản phẩm này không ?"
              onConfirm={async () => {
                await handleDeleteProduct();
                if (patientId) {
                  await handleGetPatientOverviewByIdNotLoading(patientId);
                }
              }}
            />
          )}

          {!!openConfirmDeleteMessage && (
            <ConfirmPopup
              open={!!openConfirmDeleteMessage}
              onClose={() => handleCloseDeleteConfirmMessage(null)}
              text={openConfirmDeleteMessage}
              hideConfirm
              textClose={"Quay lại"}
              title="Thao tác thất bại"
            />
          )}

          {printContent?.length > 0 && (
            <RegisterProductPreviewPrintPopup
              open={printContent?.length > 0 ? true : false}
              handleClose={() => handleSetPrintContent([])}
              patient={initialPatient}
            />
          )}
          {
            <ListStoreRequestItemPopup
              open={openListStoreRequestItemPopup}
              handleClose={handleCloseListStoreRequestItemPopup}
              initialData={initListStoreRequestItem}
            />
          }
          <RequestStoreReturnProductsPopup />
          {!!openProductHistoryPopup && (
            <ProductHistoryPopup
              open={!!openProductHistoryPopup}
              handleClose={handleCloseProductHistoryPopup}
              title="Lịch sử chỉnh sửa"
            />
          )}
          {openChangeProductPopup && (
            <ChangeProductToClientCardPopup
              handleClose={handleCloseChangeeProductPopup}
              open={openChangeProductPopup}
              initChangeProduct={initChangeProduct}
              listVatPercent={listVatPercent}
              customerSourceWalkIn={customerSourceWalkIn}
              onSubmit={handleSubmitChangeProduct}
              treatmentFree={treatmentFree}
              handleAfterSubmit={() =>
                handleGetPatientOverviewByIdNotLoading(patientId)
              }
            />
          )}

          {openConfirmUnlock && (
            <ConfirmPopup
              open={openConfirmUnlock}
              onClose={handleCloseConfirmUnlock}
              text="Bạn có muốn mở khóa sản phẩm không ?"
              onConfirm={async () => {
                await handleConfirmUnlock();
                if (patientId) {
                  setTimeout(() => {
                    handleGetPatientOverviewByIdNotLoading(patientId);
                  }, 500);
                }
              }}
            />
          )}

          {openConfirmError && (
            <ConfirmPopup
              open={openConfirmError}
              onClose={handleOpenConfirmError}
              text={openConfirmError}
              isNotAPromise
              hideConfirm
              title="Thao tác thất bại"
            />
          )}

          {openConfirmLock && (
            <ConfirmPopup
              open={openConfirmLock}
              onClose={handleCloseConfirmLock}
              text="Bạn có muốn khóa sản phẩm không ?"
              onConfirm={async () => {
                await handleConfirmLock();
                if (patientId) {
                  setTimeout(() => {
                    handleGetPatientOverviewByIdNotLoading(patientId);
                  }, 500);
                }
              }}
            />
          )}

          {openPaymentVoucherPopup && (
            <PaymentVoucherPopup
              open={openPaymentVoucherPopup}
              handleClose={handleClosePaymentVoucherPopup}
              initialPaymentVoucher={initialPaymentVoucher}
              handleSubmit={async (values, setSubmitting) => {
                console.log("🚀 ~ RegisterProductIndex ~ values:", values);
                const data = await createPaymentVoucherWithListMethod(
                  {
                    ...values,
                    notPaging: true,
                  },
                  setSubmitting
                );
                if (data?.responseStatus !== false) {
                  const drugId = values?.drugOrder?.id;
                  if (drugId) {
                    const drugList = pageRegisterProduct?.content?.find(
                      (item) => item?.id === drugId
                    );
                    if (drugList?.activeStatus !== LOCKED_STATUS) {
                      await lockProduct(drugId);
                    }
                  }
                  await handleGetPatientOverviewByIdNotLoading(patientId);
                  await pagingRegisterProduct();
                }
              }}
              patient={initialPatient?.patientInfo}
              listPaymentMethod={listPaymentMethod}
              listStk={listStk}
              listPos={listPos}
              listHomecredit={listHomecredit}
              listPos_tragop={listPos_tragop}
            />
          )}

          {openHistoryProductPopup && (
            <HistoryProductPopup
              open={openHistoryProductPopup}
              handleClose={handleCloseHistoryProductPopup}
              searchData={searchDataHistory}
              pageDataHistory={pageDataHistory}
              handleChangeFormSearch={handleChangeFormSearchHistory}
            />
          )}

          {openTotalBillStatusInvoiceItemConfirm && (
            <ConfirmPopup
              open={openTotalBillStatusInvoiceItemConfirm}
              onClose={handleCloseTotalBillStatusInvoiceItemConfirm}
              text="Bạn có muốn tính số tiền và cập nhật trạng thái thanh toán không ?"
              onConfirm={updateTotalBillStatusInvoiceItem}
            />
          )}
          {openFormLockRetained && (
            <LockRetainedPopup
              handleClose={handleCloseFormLockRetaind}
              initialValues={initialLockRetained}
              onConfirm={handleLockRetaind}
              open={openFormLockRetained}
              handleAfterSubmit={() => {
                pagingRegisterProduct();
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 400);
              }}
            />
          )}
        </Form>
      </Formik>
    </Grid>
  );
};

export default memo(observer(RegisterProductIndex));
